import { BasePostProvider } from "@tendercuts/http";
import { EndPoint } from "../base";
import { GenericServerResponse } from "@tendercuts/models/response";
import { Injectable } from "@angular/core";
import { LoginServices } from "../login";
import { HttpClient, HttpParams } from "@angular/common/http";

@Injectable({ providedIn: "root" })
export class ValidateOtpService extends BasePostProvider<
  GenericServerResponse
> {
  constructor(
    public http: HttpClient,
    public loginService: LoginServices,
    public endpointService: EndPoint
  ) {
    super(http);
  }

  get isAuthenticatedEndpoint() {
    return false;
  }
  get authProtocol() {
    return null;
  }
  get model() {
    return GenericServerResponse;
  }

  get endpoint() {
    return this.endpointService.validateOtp();
  }

  /**
   * Disable caching for this service as we want OTP generated every time
   * @override
   */
  get isCachable() {
    return false;
  }

  getParams(otp: number, phone: string) {
    let params = {
      otp_mode: "POS_VOIDBILLING",
      otp: otp,
      mobile: phone
    }

    return params;
  }
}
